<template>
	<v-dialog v-model="dialog" max-width="400px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-delete</v-icon>
					</template>
					<span>{{'delete spot' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading" class="text-md-center">
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
					{{'Would you like to delete the spot' | localize}} <span class="secondary--text">{{ spot.name }} </span>?	
			</v-card-title>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{'No' | localize}}
				</v-btn>
				<v-btn color="error" text
					class="text-capitalize"
					@click="deleteSpot">
					{{'Yes' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: ['spot'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			}
		},
		methods: {
			async deleteSpot () {
				if (this.spot && this.spot.id) {
					const id = this.spot.id
					try {
						await this.$store.dispatch('deleteSpot', id);
					}
					catch (error) {
						console.log(error.message)
					}
					this.closeDialog ()
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
			}
		}
	}
</script>
